import React, { useState, useEffect } from 'react';
import './Introduction.css';
import collegelogo from '../../assets/Home/collegelogo.png';

interface IntroductionProps {
  onComplete: () => void;
  showDuration?: number; // Duration in milliseconds (default: 3000)
  fadeDuration?: number; // Fade out duration in milliseconds (default: 1000)
}

const Introduction: React.FC<IntroductionProps> = ({ 
  onComplete, 
  showDuration = 1500, 
  fadeDuration = 1000 
}) => {
  const [isVisible, setIsVisible] = useState(true);
  const [isFading, setIsFading] = useState(false);

  useEffect(() => {
    // Show the introduction for the specified duration, then fade out
    const timer = setTimeout(() => {
      setIsFading(true);
      setTimeout(() => {
        setIsVisible(false);
        onComplete();
      }, fadeDuration); // Fade out duration
    }, showDuration); // Show duration

    return () => clearTimeout(timer);
  }, [onComplete]);

  // Prevent scrolling when introduction is visible
  useEffect(() => {
    if (isVisible) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isVisible]);

  if (!isVisible) return null;

  return (
    <div className={`introduction-overlay ${isFading ? 'fade-out' : 'fade-in'}`}>
      <div className="introduction-content">
        <div className="logo-container">
          <img src={collegelogo} alt="MEC Logo" className="introduction-logo" />
        </div>
        <div className="introduction-text">
          <h1 className="introduction-title">Model Engineering College</h1>
          <p className="introduction-subtitle">Excellence in Engineering Education</p>
        </div>
        <div className="intro-loading-dots">
          <div className="intro-dot"></div>
          <div className="intro-dot"></div>
          <div className="intro-dot"></div>
        </div>
      </div>
    </div>
  );
};

export default Introduction; 